"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertHHMMToDecimal = exports.convertHourDecimalToString = exports.convertHHMMDateToDecimal = exports.convertHHMMDataToString = exports.createHHMMString = exports.convertDateToHHMMData = exports.getDayOfWeekString = exports.convertDateNumToLocal = exports.dayStrings = void 0;
exports.dayStrings = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const convertDateNumToLocal = (date, offset) => {
    if (!date)
        return "";
    let tempUTCDate = new Date(date);
    let tempLocalDate = new Date(tempUTCDate.getTime() - ((offset ?? tempUTCDate.getTimezoneOffset()) * 60000)).toISOString().slice(0, -5);
    return tempLocalDate;
};
exports.convertDateNumToLocal = convertDateNumToLocal;
const getDayOfWeekString = (day) => {
    return exports.dayStrings[day];
};
exports.getDayOfWeekString = getDayOfWeekString;
/**
 * Converts date number into HH:MM format. Optional offset for timezone conversion.
 * @param date
 * @param offset
 * @returns
 */
const convertDateToHHMMData = (date, offset) => {
    if (!date)
        return undefined;
    const hhmm = (0, exports.convertDateNumToLocal)(date, offset).split("T")[1].slice(0, -3);
    const [hh, mm] = hhmm.split(':').map(Number);
    return ((hh * 60 * 60) + (mm * 60)) * 1000;
};
exports.convertDateToHHMMData = convertDateToHHMMData;
/**
 * Create HH:MM string from number of hours and minutes. 13 hours and 30 minutes = 13:30
 * @param hours
 * @param minutes
 * @returns
 */
const createHHMMString = (hours, minutes) => {
    return `${hours < 10 ? "0" : ""}${(hours ?? "00")}:${minutes < 10 ? "0" : ""}${minutes ?? "00"}`;
};
exports.createHHMMString = createHHMMString;
/**
 * Converts HHMM data in milliseconds into HH:MM format.
 * @param hhmm
 * @returns
 */
const convertHHMMDataToString = (hhmm) => {
    if (isNaN(hhmm))
        return "00:00";
    const hhmmTemp = hhmm / 1000;
    const minutesTemp = hhmmTemp % 3600;
    const hhmmActual = (hhmmTemp - minutesTemp) / 3600;
    const minutesActual = Math.round(minutesTemp / 60);
    return (0, exports.createHHMMString)(hhmmActual, minutesActual);
};
exports.convertHHMMDataToString = convertHHMMDataToString;
/**
 * Converts HH:MM string to raw number data. 13:30 = 13.5
 * @param hhmm
 * @returns
 */
const convertHHMMDateToDecimal = (hhmm) => {
    if (isNaN(hhmm))
        return 0;
    const hhmmTemp = hhmm / 1000;
    const minutesTemp = hhmmTemp % 3600;
    const hhmmActual = (hhmmTemp - minutesTemp) / 3600;
    const minutesActual = Math.round((minutesTemp / 3600) * 100) / 100;
    return hhmmActual + minutesActual;
};
exports.convertHHMMDateToDecimal = convertHHMMDateToDecimal;
/**
 * Converts HHMM number data into HH:MM string. 13.5 = 13:30
 * @param time
 * @returns
 */
const convertHourDecimalToString = (time) => {
    if (!time)
        return "00:00";
    const minutes = time * 10 % 10 / 10;
    const hours = Math.round(time - minutes);
    const minutesActual = Math.round(minutes * 60);
    return (0, exports.createHHMMString)(hours, minutesActual);
};
exports.convertHourDecimalToString = convertHourDecimalToString;
/**
 * Converts HH:MM string to decimal number. 13:30 = 13.5
 * @param hhmm
 * @returns
 */
const convertHHMMToDecimal = (hhmm) => {
    if (!hhmm)
        return 0;
    const [hh, mm] = hhmm.split(':').map(Number);
    const hours = hh;
    const minutes = Math.round((mm / 60) * 10) / 10;
    return hours + minutes;
};
exports.convertHHMMToDecimal = convertHHMMToDecimal;
